// Configurar rotas, caso necessário

import Vue from "vue"
import VueRouter from "vue-router"
// import Index from "../views/Index"
import Cart from "../views/Cart.vue"
import AccessDenied from "../views/NotFound.vue"

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'cart',
		component: Cart
	},
	// {
	// 	path: '/',
	// 	name: 'index',
	// 	component: Index
	// },
	{
		path: '/cart',
		name: 'cart',
		component: Cart
	},
	{
		path: '/accessDenied',
		name: 'accessDenied',
		component: AccessDenied
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

// router.beforeEach, se preciso rodar verificações todas as vezes antes de renderizar alguma tela

export default router